import { ApiPhase } from '../api-types/phase.api';
import { DB_PHASES, Phase } from '../app-types/phase.app';

/**
 * Transforms an ApiPhase object to an app-specific Phase object.
 * @description This function maps properties of the ApiPhase to the Phase interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiPhase
 * @returns Phase
 */
export const transformApiPhaseToAppPhase = (input: ApiPhase) => {
	const output: Phase = {
		id: input.id,
		remark: input.remark,
	};
	return output;
};

/**
 * Transforms an array of ApiPhase objects to an array of app-specific
 * Phase objects.
 * @param input Array of ApiPhase objects
 * @description Transforms an array of ApiPhase objects to an array of app-specific Phase objects.
 * @returns Array of app-specific Phase objects
 */
export const transformApiPhasesToAppPhases = (input: ApiPhase[]) => {
	const output: Phase[] = input.map(transformApiPhaseToAppPhase);
	return output;
};

/**
 * Transforms an app-specific Phase object to an ApiPhase object.
 * @description This function maps properties of the Phase to the ApiPhase interface.
 * It is used to convert data from the application into a format that can be sent to the API.
 * @param input Phase
 * @returns ApiPhase
 */
export const transformAppPhaseToApiPhase = (input: Phase) => {
	const output: ApiPhase = {
		id: input.id,
		remark: input.remark,
	};
	return output;
};

/**
 * Maps a phase name string (e.g. 'P3', 'FP4') to the corresponding DB_PHASES enum value.
 * Returns undefined if the name is not recognized.
 */
export const mapPhaseNameToPhaseId = (phaseName: string | null | undefined): number | undefined => {
	if (!phaseName) return undefined;
	switch (phaseName.trim().toUpperCase()) {
		case 'P0':
			return DB_PHASES.P0;
		case 'P1':
			return DB_PHASES.P1;
		case 'P2':
			return DB_PHASES.P2;
		case 'P3':
			return DB_PHASES.P3;
		case 'P4':
			return DB_PHASES.P4;
		case 'FP3':
			return DB_PHASES.FP3;
		case 'FP4':
			return DB_PHASES.FP4;
		case 'FP5':
			return DB_PHASES.FP5;
		default:
			return undefined;
	}
};
